import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { forceActiveMenuContext as ForceActiveMenuContext } from "./side-menu";

function Main() {
  const location = useLocation();
  const [forcedPath, setForcedPath] = useState<string | undefined>(undefined);

  // Clone location object with current forced path state
  const currentLocation = {
    ...location,
    forceActiveMenu: forcedPath,
  };

  return (
    <ForceActiveMenuContext.Provider
      value={{
        forceActiveMenu: (pathname: string) => {
          setForcedPath(pathname);
        },
      }}
    >
      <div className="flex md:mt-0 h-svh lg:h-dvh 2xl:h-dvh">
        <div className="md:max-w-auto min-w-0 max-w-full flex-1 overflow-hidden bg-slate-100 before:block before:h-px before:w-full before:content-[''] dark:bg-darkmode-700 md:px-[22px]">
          <Outlet context={{ location: currentLocation }} />
        </div>
      </div>
    </ForceActiveMenuContext.Provider>
  );
}

export default Main;